import { createPortal } from "react-dom";
import "./Modal.css";

const Modal = ({
  children,
  onClose,
  open,
  className = "",
  footer,
  side,
  width,
  hasBackdrop = true,
  belowHeader = false,
  style = {},
  ...rest
}) => {
  if (!open) return null;

  const isSideRight = side === "right";

  return createPortal(
    <div
      className={`modal-overlay${isSideRight ? " is-side-right" : ""}${!hasBackdrop ? " no-backdrop" : ""}${belowHeader && isSideRight ? " below-header" : ""}`}
      onClick={onClose}
    >
      <div
        className={`modal-container${isSideRight ? " is-side-right" : ""} ${className}`}
        style={{
          ...(width ? { width } : {}),
          ...style,
        }}
        onClick={(e) => e.stopPropagation()}
        {...rest}
      >
        {footer ? (
          <>
            <div className="modal-content-body">
              {children}
            </div>
            <div className="modal-content-footer">
              {footer}
            </div>
          </>
        ) : (
          children
        )}
      </div>
    </div>,
    document.body
  );
};

export default Modal;